import { render, staticRenderFns } from "./SelectWordFrequency.vue?vue&type=template&id=2c9c36b1&scoped=true&"
import script from "./SelectWordFrequency.vue?vue&type=script&lang=js&"
export * from "./SelectWordFrequency.vue?vue&type=script&lang=js&"
import style0 from "./SelectWordFrequency.vue?vue&type=style&index=0&id=2c9c36b1&scoped=true&lang=css&"
import style1 from "./SelectWordFrequency.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c9c36b1",
  null
  
)

export default component.exports